export default "/images/monitor.svg?cd5cd51c1dc1a8dc962dd3014aae0471";